module.exports = __webpack_public_path__ + "img/cancelled-stamp.85c74f5.png";